/*eslint-disable*/
import gamePreviewMixin from '../trainer/gamePreviewMixin'

export default {
    mixins: [gamePreviewMixin],
    data () {
        return {
            operations: {
                rootExtraction: this.$i18n.t('trainer.trainer_gameFormSetting_operationRootExtraction'),
                exponentiation: this.$i18n.t('trainer.trainer_gameFormSetting_operationExponentiation'),
            },
            extraOperations: {
                endsWithFiveSquare: 'А5²',
                endsWithOneSquare: 'А1²',
                endsWithNineSquare: 'А9²',
            },
        }
    },
    methods: {
        field (prop) {
            let fields = []
            for (let key in this.settings[prop]) {
                this.settings[prop][key] && fields.push(this[prop][key])
            }
            return fields.join(', ')
        }
    },
    computed: {
        areExtraOperationsEnabled() {
            return this.settings.extraOperations && Object.values(this.settings.extraOperations).find(extraOperation => extraOperation === true);
        },
    },
}
